import { create } from "apisauce";
import Config from "../../config";

// Base
import { ApiResponse } from "../api/interfaces/ApiResponse";

// Requests
import {
  PartnerAuthRequest,
  VerifySettingsRequest,
  UpdateSettingsRequest,
  RetrieveTotalPetRequest,
  VerifySyncRequest,
  VerifySyncSectionRequest,
  UpdateSyncSectionRequest,
  SyncOneRequest,
  SyncAbortRequest,
  VerifyShelterRequest,
  ListAdoptionStatusRequest,
  NotifyAdoptionInfoRequest,
  ConnectRequest,
  DisconnectRequest,
  SetMainRequest,
  PreviewRequest,
  UpdateNetworkSettingsRequest,
  VerifyNetworkSettingsRequest,
  RetrieveNetworkTotalPetRequest,
  SbRequest,
} from "./interfaces/ApiRequest";

// Responses
import {
  PartnerAuthResponse,
  VerifySettingsResponse,
  UpdateSettingsResponse,
  RetrieveTotalPetResponse,
  VerifySyncResponse,
  SyncOneResponse,
  SyncAbortResponse,
  VerifySyncSectionResponse,
  UpdateSyncSectionResponse,
  VerifyShelterResponse,
  ListAdoptionStatusResponse,
  NotifyAdoptionInfoResponse,
  ConnectResponse,
  DisconnectResponse,
  SetMainResponse,
  PreviewResponse,
  ListPaymentMethodResponse,
  ListReceiptAccountResponse,
  ListOptInChoicesResponse,
  ListLocationsResponse,
  ListImportStatusResponse,
  ListTransitionStatusResponse,
  SbListAdoptionStatusResponse,
  ListIconResponse,
} from "./interfaces/ApiResponse";

// Create our ApiSauce instance
const api = create({
  baseURL: Config.integrationAPI,
});

// Configurations
export const setToken = (token: string) =>
  api.setHeader("Authorization", `Bearer ${token}`);

// Partner methods
export const partnerAuth = async (data: PartnerAuthRequest) =>
  (await api.post(data.endpoint, data)) as ApiResponse<PartnerAuthResponse>;
export const partnerListAdoptionStatus = async (
  data: ListAdoptionStatusRequest
) =>
  (await api.post(
    `${data.partner}/list-adoption-status`,
    data
  )) as ApiResponse<ListAdoptionStatusResponse>;

// Settings methods
export const verifySettings = async (data: VerifySettingsRequest) =>
  (await api.post(
    "verify/settings",
    data
  )) as ApiResponse<VerifySettingsResponse>;
export const verifyNetworkSettings = async (
  data: VerifyNetworkSettingsRequest
) =>
  (await api.post(
    "verify/settings",
    data
  )) as ApiResponse<VerifySettingsResponse>;
export const updateSettings = async (data: UpdateSettingsRequest) =>
  (await api.post(
    "update/settings",
    data
  )) as ApiResponse<UpdateSettingsResponse>;
export const updateNetworkSettings = async (
  data: UpdateNetworkSettingsRequest
) =>
  (await api.post(
    "update/settings",
    data
  )) as ApiResponse<UpdateSettingsResponse>;

// Retrieve methods
export const retrieveTotalPet = async (data: RetrieveTotalPetRequest) =>
  (await api.post(
    "retrieve/total-pets",
    data
  )) as ApiResponse<RetrieveTotalPetResponse>;
export const retrieveNetworkTotalPet = async (
  data: RetrieveNetworkTotalPetRequest
) =>
  (await api.post(
    "retrieve/total-pets",
    data
  )) as ApiResponse<RetrieveTotalPetResponse>;

// Sync methods
export const verifySync = async (data: VerifySyncRequest) =>
  (await api.post("verify/sync", data)) as ApiResponse<VerifySyncResponse>;
export const verifySyncSection = async (data: VerifySyncSectionRequest) =>
  (await api.post(
    "verify/sync-sections",
    data
  )) as ApiResponse<VerifySyncSectionResponse>;
export const updateSyncSection = async (data: UpdateSyncSectionRequest) =>
  (await api.post(
    "update/sync-section",
    data
  )) as ApiResponse<UpdateSyncSectionResponse>;
export const syncOne = async (data: SyncOneRequest) =>
  (await api.post("sync/one", data)) as ApiResponse<SyncOneResponse>;
export const syncAbort = async (data: SyncAbortRequest) =>
  (await api.post("sync/abort", data)) as ApiResponse<SyncAbortResponse>;

// Integration methods
export const connect = async (data: ConnectRequest) =>
  (await api.post("integration/connect", data)) as ApiResponse<ConnectResponse>;
export const disconnect = async (data: DisconnectRequest) =>
  (await api.post(
    "integration/disconnect",
    data
  )) as ApiResponse<DisconnectResponse>;
export const setMain = async (data: SetMainRequest) =>
  (await api.post(
    "integration/set-main",
    data
  )) as ApiResponse<SetMainResponse>;
export const preview = async (data: PreviewRequest) =>
  (await api.post("integration/preview", data)) as ApiResponse<PreviewResponse>;

// Shelter methods
export const verifyShelter = async (data: VerifyShelterRequest) => {
  const response = (await api.post(
    "verify/shelter",
    data
  )) as ApiResponse<VerifyShelterResponse>;


  return response
}


// Notify methods
export const notifyAdoptionInfo = async (data: NotifyAdoptionInfoRequest) =>
  (await api.post(
    "notify/adoption-info",
    data
  )) as ApiResponse<NotifyAdoptionInfoResponse>;

export const integrationNetworkList = async (data: any) =>
  (await api.post("network/search?convert=true", data)) as ApiResponse<any>;
export const integrationNetworkListSimple = async (data: any) =>
  (await api.post("network/search", data)) as ApiResponse<any>;
export const integrationNetworkConnect = async (data: any) =>
  (await api.post("network/connect", data)) as ApiResponse<any>;
export const integrationNetworkDisconnect = async (data: any) =>
  (await api.post("network/disconnect", data)) as ApiResponse<any>;
export const integrationNetworkCreate = async (data: any) =>
  (await api.post("network/create?convert=true", data)) as ApiResponse<any>;
export const integrationNetworkUpdate = async (data: any) =>
  (await api.post("network/update?convert=true", data)) as ApiResponse<any>;
export const integrationDefinitionsList = async (data: any) =>
  (await api.post(
    "characteristics-definition/search?convert=true",
    data
  )) as ApiResponse<any>;
export const integrationDefinitionsListSimple = async (data: any) =>
  (await api.post(
    "characteristics-definition/search",
    data
  )) as ApiResponse<any>;
export const integrationDefinitionsCreate = async (data: any) =>
  (await api.post(
    "characteristics-definition/create?convert=true",
    data
  )) as ApiResponse<any>;
export const integrationDefinitionsUpdate = async (data: any) =>
  (await api.post(
    "characteristics-definition/update?convert=true",
    data
  )) as ApiResponse<any>;
export const integrationDefinitionsConnect = async (data: any) =>
  (await api.post(
    "characteristics-definition/connect",
    data
  )) as ApiResponse<any>;
export const integrationDefinitionsDisconnect = async (data: any) =>
  (await api.post(
    "characteristics-definition/disconnect",
    data
  )) as ApiResponse<any>;

// SB methods
export const sbListPaymentMethod = async (data: SbRequest) =>
  (await api.post("shelterbuddy/list-payment-methods", data)) as ApiResponse<ListPaymentMethodResponse>;
export const sbListReceiptAccount = async (data: SbRequest) =>
  (await api.post("shelterbuddy/list-receipt-account", data)) as ApiResponse<ListReceiptAccountResponse>;
export const sbListOptInChoices = async (data: SbRequest) =>
  (await api.post("shelterbuddy/list-opt-in-choices", data)) as ApiResponse<ListOptInChoicesResponse>;
export const sbListLocations = async (data: SbRequest) =>
  (await api.post("shelterbuddy/list-locations", data)) as ApiResponse<ListLocationsResponse>;
export const sbListImportStatus = async (data: SbRequest) =>
  (await api.post("shelterbuddy/list-import-status", data)) as ApiResponse<ListImportStatusResponse>;
export const sbListTransitionStatus = async (data: SbRequest) =>
  (await api.post("shelterbuddy/list-transition-status", data)) as ApiResponse<ListTransitionStatusResponse>;
export const sbListAdoptionStatus = async (data: SbRequest) =>
  (await api.post("shelterbuddy/list-adoption-status", data)) as ApiResponse<SbListAdoptionStatusResponse>;
export const sbListIcon = async (data: SbRequest) =>
  (await api.post("shelterbuddy/list-icon", data)) as ApiResponse<ListIconResponse>;

api.axiosInstance.interceptors.response.use((response) => {
  // const listResponseStatus = HandlerList;
  // if (response.data.status !== 200 && response.data?.prefix) {
  //   const match =
  //     listResponseStatus[response.data.prefix].match[response.data.status];

  //   const _defaultWithPrefix = listResponseStatus[response.data.prefix].default;
  //   const _default = listResponseStatus.default;

  //   if(!_defaultWithPrefix){
  //     _default(response.data)
  //   }
  //   if(!match){
  //     _defaultWithPrefix(response.data)
  //   }
  //   if (match) {
  //     match(response.data)
  //   }
  // }

  return response;
});
